// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"b937893d","331":"a97fe178","589":"540e23c9"}[chunkId] + ".chunk.js";
};